import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { MechanicalLoadDiagram } from "./MechanicalLoadDiagram ";

export const SMLview = ({ procedureData }: { procedureData: any }) => {
  const [open, setOpen] = React.useState(false);

  const [selectedRow, setSelectedRow] = React.useState<string>("");
  const rowRefs = React.useRef<Record<string, HTMLTableRowElement | null>>({});

  const isV12SMLTTF =
    procedureData?.tsd_version === "v12" &&
    procedureData?.procedure_definition_name === "SML-TTF";

  const handleSelectRow = (rowName: string) => {
    setSelectedRow(rowName);

    rowRefs.current[rowName]?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const results = procedureData?.smlttf?.results ?? [];

  const statKeys =
    results.length > 0 ? Object.keys(results[0].stats || {}) : [];


  const handleClose = () => {
    setOpen(!open);
  };
  return (
    <div>
      <Typography variant="body1">
        Ambient temperature :{" "}
        {procedureData?.sml?.ambient_temperature
          ? `${procedureData.sml.ambient_temperature} °C`
          : "N/A"}
      </Typography>
      <Typography variant="body1">
        Ambient humidity :
        {procedureData?.sml?.ambient_humidity
          ? `${procedureData.sml.ambient_humidity} %RH`
          : "N/A"}
      </Typography>
      <Typography variant="body1">
        Calibration Date :
        {procedureData?.sml?.equipment_calibration_date
          ? procedureData.sml.equipment_calibration_date.substring(0, 10)
          : "N/A"}
      </Typography>
      <Typography variant="body1">
        Installation method :
        {procedureData?.sml?.installation_method
          ? procedureData.sml.installation_method
          : "N/A"}
      </Typography>
      <Typography variant="body1">
        Mounting hardware :
        {procedureData?.sml?.mounting_hardware
          ? procedureData.sml.mounting_hardware
          : "N/A"}
      </Typography>

      <Button variant="contained" color="primary" onClick={handleClose}>
        Mechanical Load
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={false}
        maxWidth="xl"
      >
        <DialogTitle id="id">
          <div>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>{"Mechanical Load"}</Box>
              <Box>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </div>
        </DialogTitle>
        <DialogContent>
          <Divider variant="fullWidth" />

          {isV12SMLTTF ? (
            <>
              <MechanicalLoadDiagram onSelectRow={handleSelectRow} />
              <TableContainer
                component={Paper}
                style={{
                  maxHeight: 400, // or height: 400
                  overflowY: "auto",
                }}
              >
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b></b>
                      </TableCell>

                      {results.map((result: any, index: number) => (
                        <TableCell key={index} align="center">
                          <b>{result.pressure} Pa</b>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {statKeys.map((statKey: string) => (
                      <TableRow
                        key={statKey}
                        ref={(el) => {
                          rowRefs.current[statKey] = el;
                        }}
                        style={{
                          backgroundColor:
                            selectedRow === statKey ? "#FFF59D" : "transparent",
                        }}
                      >
                        <TableCell>
                          <b>{statKey}</b>
                        </TableCell>

                        {results.map((result: any, index: number) => (
                          <TableCell key={index} align="center">
                            {result.stats?.[statKey] ?? "-"}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <TableContainer component={Paper}>
              <Table size="medium">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Test Pressure (Pa)</b>
                    </TableCell>
                    {!isV12SMLTTF && (
                      <TableCell>
                        <b>Test Duration (hours)</b>
                      </TableCell>
                    )}
                    {/* <TableCell><b>Test Direction </b></TableCell> */}
                    {!isV12SMLTTF && (
                      <TableCell>
                        <b>Dut Circuit Normal </b>
                      </TableCell>
                    )}
                    {!isV12SMLTTF && (
                      <TableCell>
                        <b>Test Direction </b>
                      </TableCell>
                    )}
                    <TableCell>
                      <b>Dut Deflection (mm)</b>
                    </TableCell>
                    <TableCell>
                      <b>Load Uniformity (%)</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {procedureData?.sml?.entries?.map(
                    (data: any, index: number) => (
                      <TableRow key={index}>
                        <TableCell>{data.test_pressure}</TableCell>
                        {!isV12SMLTTF && (
                          <TableCell>{data.test_duration}</TableCell>
                        )}
                        {/* <TableCell>{data.test_direction}</TableCell> */}
                        {!isV12SMLTTF && (
                          <TableCell>{data.dut_circuit_normal}</TableCell>
                        )}
                        {!isV12SMLTTF && (
                          <TableCell>{data.test_surface}</TableCell>
                        )}
                        <TableCell>{data.dut_deflection}</TableCell>
                        <TableCell>{data.load_uniformity}</TableCell>
                      </TableRow>
                    ),
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={handleClose}>
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
